import { hasAccessToRoute, isEnvironmentalCleaningActive } from '@silbo/core';
import { useAuthenticationContext } from '../../../contexts/AuthenticationContext';
import { useConfigContext } from '../../../contexts/ConfigContext/useConfigContext';

export type CleaningAccessRefusal = 'cleaning-disabled' | 'page-not-in-profile';

export type CleaningAccess =
  | { status: 'loading' }
  | { status: 'granted' }
  | { status: 'refused'; reason: CleaningAccessRefusal };

/** Le nettoyage s'ouvre quand le réglage de l'établissement n'est pas désactivé et que le profil porte la page. */
export const useCleaningAccess = (): CleaningAccess => {
  const { user } = useAuthenticationContext();
  const { config, isLoading } = useConfigContext();

  if (isLoading) {
    return { status: 'loading' };
  }
  if (!isEnvironmentalCleaningActive(config?.environmentalCleaning)) {
    return { status: 'refused', reason: 'cleaning-disabled' };
  }
  const profileHasCleaningPage = hasAccessToRoute(user?.navigationACL ?? [], 'mobile.environmentalCleaning');
  if (!profileHasCleaningPage) {
    return { status: 'refused', reason: 'page-not-in-profile' };
  }
  return { status: 'granted' };
};
